import { render } from "./OTPComponent.vue?vue&type=template&id=147505e2"
import script from "./OTPComponent.vue?vue&type=script&lang=js"
export * from "./OTPComponent.vue?vue&type=script&lang=js"

import "./OTPComponent.vue?vue&type=style&index=0&id=147505e2&lang=scss"

import exportComponent from "D:\\source\\Mobaxe.Docs.App\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__